
import styled from 'styled-components';

import Box from '../Box';
import Text from '../Text';

export const Increment = styled(Box)`
  counter-increment: ${({ name }) => name};
`;

export const Offset = styled(Box)`
  counter-reset: ${({ offset, name }) => `${name} ${offset}`};
`;

export const Counter = styled(Text)`
  ${({ name, type }) => {
    if (!name) return;
    return `
      &::before {
        content: counter(${name + (type ? `, ${type}` : '')}) ". ";
      }
    `;
  }}

`;
